import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Row,
          Col,
          Button,
          FormGroup,
          Tabs,
          Tab,
          FormControl,
          Table,
          Modal,
          ControlLabel,
          Label,
          ButtonGroup,
          DropdownButton,
          MenuItem,} from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Loading from "../../components/loading";
import FormBuilderPage from '../../pages/formbuilder';
import UsersService from "../../services/users-service";
import FormsService from "../../services/forms-service";
import FormdataService from "../../services/formdata-service";
import GLOBALS from '../../utils/Constants';
import {ToastContainer, ToastStore} from 'react-toasts';
import Moment from 'react-moment';
import './style.css';

class Forms extends Component {

    constructor(props, context) {
        super(props, context);

        var forms = [
            {form_id: "1", form_name: "Post Incident Report", date_added: "Dec. 3, 2018 @ 8:00 PM", branch: "Indianapolis", facility: "Lucas Oil"},
            {form_id: "2", form_name: "Daily Activity Summary Report", date_added: "Dec. 3, 2018 @ 8:00 PM", branch: "West Lafayette", facility: "Purdue Stadium"},
            {form_id: "3", form_name: "Annual Report", date_added: "Dec. 3, 2018 @ 8:00 PM", branch: "Washington D.C.", facility: "ALL"},
        ];
        //var forms = null;
        const storedCredentials = UsersService.sharedInstance.getStoredCredentials();

        this.state = {
            show: false,
            forms: forms,
            formToEdit: null,//Form clicked, either via edit button or whatevers
            file:null,
            isUploading:false,
            storedCredentials:storedCredentials,
            file: null,
            showFormInputModal: false,
            currentForm: null,//Clicked form
            page: 0,//Use this to load different "pages" within the Forms page. Like Add Form.
            newFormClient: "select",
            newFormBranch: "select",
            newFormFacility: "select",
            clients: null,
            branches: null,
            facilities: null
        }

        this.showFileUpload = this.showFileUpload.bind(this);
        this.downloadFile = this.downloadFile.bind(this);
        this.getClientsBranchAndFacility = this.getClientsBranchAndFacility.bind(this);
        this.validateDropdown =  this.validateDropdown.bind(this);
    }

    componentWillMount(){
        //this.getClientsBranchAndFacility();
    }

    componentDidMount() {
      this.setState({
        forms: this.props.forms
      });
    }

    componentDidUpdate(prevProps) {
      if(JSON.stringify(prevProps.forms) != JSON.stringify(this.state.forms)) {
        this.setState({
          forms: this.props.forms
        });
      }
    }

    showFileUpload(){
        this.fileInput.click();
    }

    downloadFile(filename){
        const license =  this.state.storedCredentials.loginResponse.data[0].User_License;
        const filePath = GLOBALS.CSA_FORMS_S3_PATH + license + "/" + filename + ".csv";
        window.open(filePath);
    }

    onChangeFile(event) {
        event.stopPropagation();
        event.preventDefault();
        var file = event.target.files[0];
        this.setState({
            file:file,
        }); /// if you want to upload latter
    }

    getClientsBranchAndFacility(){
       //THIS IS NOT USED FOR NOW
        const storedCredentials = this.state.storedCredentials;
        const loginResponse = storedCredentials.loginResponse;

        var params = {
          "license":loginResponse.data[0].User_License,
          "auth_username":loginResponse.data[0].User_ID,
          "token":loginResponse.token_data.token
        };

        FormdataService.sharedInstance.getDropdownDataForAddForm(params)
        .then((response)=>{
            this.setState({
              clients:response.clients,
              facilities:response.facilities,
              branches:response.branches
            })
        }).catch((error)=>{
            console.log("getClientsBranchAndFacility ERR", error);
        });
    }

    render(){

        return(this.processContent())
    }

    processContent() {
      var page = this.state.page;

      switch(page) {
        case 0:
          return this.renderFormTable();
        case 1:
          return this.renderAddNewForm();
        case 2:
          return this.renderFormBuilder();
        default:
          return <div>Unknown Page! Check processContent()!</div>
        break;
      }
    }

    renderFormTable() {
      return (<div className="reports-main-content">
                  <div className="">
                          <Button className="control-btn green-btn"  onClick={()=>{this.setState({page: 1})}}>Add Form</Button>
                  </div>
                  <div className="forms-table">
                      <Table striped hover>
                          <thead>
                              <tr >
                                  <th style={{textAlign: "center"}}>Forms</th>
                                  <th style={{textAlign: "center"}}>Branch</th>
                                  <th style={{textAlign: "center"}}>Facility</th>
                                  <th style={{textAlign: "center"}}>Actions</th>
                              </tr>
                          </thead>
                          <tbody>
                              {this.props.forms != null && this.props.forms.length > 0
                                  ? this.props.forms.map((item, index)=>{
                                      return (
                                          <tr key={item.recno + "_"+index}>
                                              <td className="form-name">{item.form_name}</td>
                                              <td className="form-name">{item.branch_name}</td>
                                              <td className="form-name">{item.facility_name}</td>
                                              <td className="form-actions">

                                                  <Button className="action-button"
                                                        onClick={()=>{
                                                          this.setState({
                                                            page: 2,
                                                            formToEdit: item
                                                          })
                                                        }}>
                                                      <FontAwesomeIcon className="icon" icon="pencil-alt"/>
                                                  </Button>
                                                  <Button className="action-button"
                                                          onClick={()=>{
                                                            this.deleteForm(item.recno);
                                                          }}>
                                                      <FontAwesomeIcon className="icon" icon="trash-alt"/>
                                                  </Button>
                                              </td>
                                          </tr>
                                      )
                                  })
                                  : <tr>
                                      <td className="form-name" colSpan={5} style={{textAlign: "center"}}>No Forms</td>
                                    </tr>
                              }

                          </tbody>
                      </Table>
                  </div>
              </div>);
    }

    renderAddNewForm() {
      var clients = this.props.clients;
      var branches = this.props.branches;
      var facilities = this.props.facilities;

      var hasClients = clients != null && clients.length > 0;
      var hasBranches = branches != null && branches.length > 0;
      var hasFacilities = facilities != null && facilities.length > 0;

      return <div className="reports-main-content" style={{flexDirection: "column"}}>

                <div className="controls-div">
                        <Button className="back-link-btn green-btn" onClick={()=>{this.setState({page: 0})}}>Back To Forms List</Button>
                </div>
                <div className="content-div">
                        <h1 className="orange-title">Add New Form</h1>
                          <br/>
                          <br/>
                          <br/>
                          <div style={{flexDirection: "column"}}>
                            {
                              //<div>
                              //   <Button className="btn blue-btn" onClick={()=>{this.showFileUpload()}}>Choose File</Button>
                              // {this.state.file ? this.state.file.name : ""}
                              // <FormControl
                              //    id="fileUpload"
                              //    type="file"
                              //    accept=".csv"
                              //    onChange={this.onChangeFile.bind(this)}
                              //    style={{ display: "none" }}
                              //    inputRef={input => this.fileInput = input}/>
                              //</div>
                            }


                            <br/>
                            <div  style={{flexDirection: "row"}}>
                              <FormGroup controlId="branchDropDown" className="col-md-2 col-md-offset-5" style={{textAlign: "center"}}>
                                <Button className="btn green-btn" onClick={()=>{this.setState({page: 2})}}>Form Builder</Button>
                              </FormGroup>
                            </div>
                            <br/>
                            <div style={{flexDirection: "row", background: "green"}}>
                              <FormGroup controlId="clientDropdown" className="col-md-2 col-md-offset-5" style={{textAlign: "left"}}>
                                <ControlLabel htmlFor="clientDropdown" className="control-label">Select Client</ControlLabel>
                                <FormControl  componentClass="select" placeholder="Client"
                                              style={{width: "100%"}}
                                              defaultValue={"select"}
                                              value={this.state.newFormClient ? this.state.newFormClient : "select"}
                                              onChange={(e)=>{this.setState({newFormClient: e.target.value})}}>

                                              {hasClients ? <option value="select">Select Client</option> : null}
                                              {hasClients ? <option value="all">All</option> : null}
                                    {hasClients
                                        ? clients.map((client, index) => {
                                            if(client.is_active == 1)
                                              return <option key={index} value={client.id+"_"+client.client_name}>{client.client_name}</option>
                                          })
                                        : <option disabled value="select">No Clients</option>
                                    }
                                </FormControl>
                              </FormGroup>
                            </div>

                            <br/>
                            <div  style={{flexDirection: "row"}}>
                              <FormGroup controlId="branchDropDown" className="col-md-2 col-md-offset-5" style={{textAlign: "left"}}>
                                <ControlLabel htmlFor="branchDropDown" className="control-label">Select Branch</ControlLabel>
                                <FormControl  componentClass="select" placeholder="Branch"
                                              style={{width: "100%"}}
                                              defaultValue={"select"}
                                              value={this.state.newFormBranch}
                                              onChange={(e)=>{this.setState({newFormBranch: e.target.value})}}>
                                              {hasBranches ? <option value={"select"}>Select Branch</option> : null}
                                              {hasBranches ? <option value="all">All</option> : null}
                                    {hasBranches
                                        ? branches.map((branch) => {
                                            if(branch.is_active == 1)
                                              return <option key={branch.id} value={branch.id+"_"+branch.branch_name}>{branch.branch_name}</option>
                                          })
                                        : <option disabled value="select">No Branch</option>
                                    }
                                </FormControl>
                              </FormGroup>
                            </div>


                            <br/>
                            <div  style={{flexDirection: "row"}}>
                              <FormGroup controlId="facilityDropdown" className="col-md-2 col-md-offset-5" style={{textAlign: "left"}}>
                                <ControlLabel htmlFor="facilityDropdown" className="control-label">Select Facility</ControlLabel>
                                <FormControl componentClass="select" placeholder="Facility"
                                              style={{width: "100%"}}
                                              defaultValue={"select"}
                                              value={this.state.newFormFacility}
                                              onChange={(e)=>{this.setState({newFormFacility: e.target.value})}}>
                                              {hasFacilities ? <option value="select">Select Facility</option> : null}
                                              {hasFacilities ? <option value="all">All</option> : null}
                                    {hasFacilities
                                        ? facilities.map((facility) => {
                                            if(facility.is_active == 1)
                                              return <option key={facility.facility_id} value={facility.facility_id+"_"+facility.facility_name}>{facility.facility_name}</option>
                                          })
                                        : <option disabled value="select">No Facility</option>
                                    }
                                </FormControl>
                              </FormGroup>
                            </div>


                            <br/>
                            <br/>
                            <div  style={{flexDirection: "row"}}>
                              <FormGroup controlId="branchDropDown" className="col-md-2 col-md-offset-5" style={{textAlign: "center"}}>
                                <Button className="btn green-btn" onClick={()=>{this.submitForm()}}>Add Form</Button>
                              </FormGroup>
                            </div>
                          </div>

                </div>
                  { <Loading isShowing={this.state.isUploading} message="Adding New Form. . ."/>}
              </div>
    }

    renderFormBuilder() {
      return <FormBuilderPage back={()=>{this.setState({page: 1, formToEdit: null})}}
                    forms={this.props.forms}
                    formToEdit={this.state.formToEdit}
                    facilities={this.props.facilities}
                    clients={this.props.clients}
                    branches={this.props.branches}
                    mode={"edit"}
                    getAllFormsByLicense={this.props.getAllFormsByLicense}
                    formDataUpdateData={this.props.formDataUpdateData}
                    updateData={this.props.updateData}/>
    }

    submitForm() {
      const storedCredentials = this.state.storedCredentials;
      const loginResponse = storedCredentials.loginResponse;
      const sub_user_id = loginResponse.data[0].recno;

      var file = this.state.file;

      if(!file){
        ToastStore.error("Please upload a form.");
        return false;
      }

      let branch_array = this.validateDropdown(this.state.newFormBranch, "branch");
      let facility_array = this.validateDropdown(this.state.newFormFacility, "facility");
      let client_array = this.validateDropdown(this.state.newFormClient, "client");

      if(!branch_array || !facility_array || !client_array){
         ToastStore.error("Please enter correct details in the form.");
         return false;
      }

      var params = {
        "license":loginResponse.data[0].User_License,
        "auth_username":loginResponse.data[0].User_ID,
        "token":loginResponse.token_data.token,
        "sub_user_id":sub_user_id,
        "file":file,
        //New Stuff
        "client_id": client_array[0],
        "client_name": client_array[1],
        "branch_id": branch_array[0],
        "branch_name": branch_array[1],
        "facility_id": facility_array[0],
        "facility_name": facility_array[1],
      };


      this.setState({
          isUploading: true,
      });

      FormsService.sharedInstance.uploadFormsToS3(params)
      .then((response)=>{
          this.setState({
              isUploading: false,
              newFormBranch: "select",
              newFormFacility: "select",
              newFormClient: "select",
              file: null
          });

          if(response.success == 0){
              ToastStore.error(response.code_error);
          }
          else{
             this.setState({page: 0});
             this.props.getAllFormsByLicense();
          }
      }).catch((error)=>{
          this.setState({
              isUploading: false,
          });
      });
    }

    deleteForm(id) {
      const storedCredentials = this.state.storedCredentials;
      const loginResponse = storedCredentials.loginResponse;
      const sub_user_id = loginResponse.data[0].recno;
      var params = {
        "token":storedCredentials.token,
        "auth_username":loginResponse.data[0].User_ID,
        "license":storedCredentials.license,
        "id": id,
      };

      FormsService.sharedInstance.delete(params)
      .then((response)=>{
          if(response.success == 0){
              ToastStore.error(response.code_error);
          }
          else{
            ToastStore.success("Form Deleted");
             this.setState({page: 0});
             this.props.getAllFormsByLicense();
          }
      }).catch((error)=>{
          console.log(error);
          ToastStore.error("Error deleting form.");
      });

    }

    validateDropdown(dropdown, type){
      if(dropdown != "all" && dropdown != "select"){
        return dropdown.split("_");
      }
      else{
        if(dropdown == "all"){
          return ["-1", "All"];
        }
        else{
          return false;
        }
      }
    }
}

export default Forms;
